import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        debug: false,
        // Only add ns that needs to be preloaded.
        // A namespace that is not preloaded makes useTranslation suspend on first use. Because the
        // route tree sits inside <Suspense fallback={null}>, that suspension throws away the whole
        // in-progress render, so every render-phase useQuery in the subtree re-fires on each retry.
        // Preloading the namespaces the main order/client screens declare avoids that churn.
        // country-names (the address boxes), workflow and milling-jobs are read by the lab order's
        // delivery step; a suspension there froze the tab when it met a re-render loop (DD-3654).
        ns: [
            'common',
            'navigation',
            'orders',
            'users',
            'client-directory',
            'patient',
            'errors',
            'country-names',
            'workflow',
            'milling-jobs',
            // DD-3697: the price-request pages render editable grids under Suspense.
            'price-requests',
            // DD-3800: the Production › Overview page renders its calendar under Suspense.
            'production-overview',
        ],
        // The ns to use for useTranslation() without any ns given
        defaultNS: 'common',
        // 'cimode' forces display of the labels without translation
        fallbackLng: 'en_US',
        // Crowdin exports texts nobody has translated yet as "". Treat those as missing so the
        // English text is shown instead of a blank label.
        returnEmptyString: false,
        lng: 'en_US',
        supportedLngs: ['en_US', 'sv_SE', 'no_NO', 'da_DK', 'fi_FI', 'de_DE', 'nl_NL', 'pl_PL', 'debug'],
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;
